export enum ClosedLoopAssignType {    
    DASH = 1,
    Donor = 2,
    DonorShieldDirect = 3,
    WaTR = 4,
    FollowUp = 5
}